import { ReplaySubject } from 'rxjs';
import { AddressModel, ProfileAddressModel } from '../../../../shared/models/addressModel';
import RolePermissionService from "../../../../shared/role-permissions/rolePermissionService";
import { AgGridColumnExt } from '../../../../shared/services/ag-grid/agGridColumnExt';
import { DataService } from "../../../../shared/services/dataService";
import DynamicControlService from '../../../../shared/services/dynamicControlService';
import LookupService from "../../../../shared/services/lookupService";
import { MatIconService } from '../../../../shared/services/theme/matIconService';
import { CrudAction, ENTITY_FIELD_TYPE, ResultStatus } from '../../../../shared/types/enums';
import { TemplateFieldConfigUtil } from '../../../../shared/utilities/templateFieldConfigUtil';

export default class ProfileTabService {

    static gridColumnGroupKey = 99;
    static otherFieldGroupKey = 100;
    static filterFieldGroupKey = 1;
    static staticFieldGroupKey = 2;
    static customFieldGroupKey = 3;

    static readonlyFieldIds = []; // filled in the INIT method

    static companyProfileID = 1;
    static porzioGSTProfileID = 2;
    static profileCategoryFieldId = 6;
    static profileStatusFieldId = 133;

    static recipinetProfileTypeLovOptions = [];
    static recipinetIdentifierTypeLovOptions = [];

    // Address Grid
    static addressesFieldGroupKey = 4;
    static addressFieldIds = []; // filled in the INIT method
    static addressIsActiveFieldId = 137;
    static addressIsPrimaryFieldId = 121;
    static address1FieldId = 12;
    static address2FieldId = 13;
    static address3FieldId = 14;
    static address4FieldId = 124;
    static addressCityFieldId = 15;
    static addressProvinceFieldId = 16;
    static addressPostalCodeFieldId = 18;
    static addressCountryFieldId = 17;
    static companyAddressIDFieldId = 122;
    static porzioGSTAddressIDFieldId = 12;

    // Contact Grid
    static contactMethodsFieldGroupKey = 5;
    static contactMethodFieldIds = []; // filled in the INIT method
    static contactIsActiveFieldId = 139;
    static contactIsPreferredFieldId = 129;
    static contactTypeFieldId = 131;
    static contactInformationFieldId = 132;
    static contactCountryFieldId = 130;
    static companyContactIdFieldId = 128;
    static porzioGSTContactIDFieldId = 127;

    // Identifier Grid
    static identifierFieldGroupKey = 6;
    static identifierFieldIds = []; // filled in the INIT method
    static identifierTypeFieldId = 21;
    static identifierCountryFieldId = 125;
    static identifierValueFieldId = 22;
    static identifierDescriptionFieldId = 126;
    static identifierCompanyFieldId = 20;
    static porzioGSTIdentifierFieldId = 126;

    // Consent Grid
    static consentFieldGroupKey = 7;
    static consentFieldIds = []; // filled in the INIT method
    static consentFieldId = 120;
    static consentStartDateFieldId = 135;
    static consentEndDateFieldId = 136;
    static consentExecutedDateFieldId = 261;

    static INIT = (isNew) => {
        // readonly fields
        this.readonlyFieldIds = [];
        if (!isNew) {
            this.readonlyFieldIds.push(this.companyProfileID);
        }

        // address columns
        this.addressFieldIds = [
            this.addressIsActiveFieldId, this.addressIsPrimaryFieldId,
            this.address1FieldId, this.address2FieldId, this.address3FieldId, this.address4FieldId,
            this.addressCityFieldId, this.addressProvinceFieldId, this.addressPostalCodeFieldId, this.addressCountryFieldId,
            this.companyAddressIDFieldId, this.porzioGSTAddressIDFieldId
        ];

        // contact columns
        this.contactMethodFieldIds = [
            this.contactIsActiveFieldId, this.contactIsPreferredFieldId,
            this.contactTypeFieldId, this.contactInformationFieldId, this.contactCountryFieldId,
            this.companyContactIdFieldId, this.porzioGSTContactIDFieldId
        ];

        // identifier columns
        this.identifierFieldIds = [
            this.identifierTypeFieldId, this.identifierCountryFieldId,
            this.identifierValueFieldId, this.identifierDescriptionFieldId,
            this.identifierCompanyFieldId, this.porzioGSTIdentifierFieldId
        ];

        // consent columns
        this.consentFieldIds = [
            this.consentFieldId, this.consentStartDateFieldId,
            this.consentEndDateFieldId, this.consentExecutedDateFieldId,
        ];

    }

    static getGroupFieldsMap = (_compThisRef, _isNew, _templateConfigData, _sortProp1, _sortProp2, _forGrid = false) => {
        // hardcode the prfile-status dropdown, etc,...
        _templateConfigData = this.hardcodeFields(_compThisRef, _isNew, _templateConfigData);

        // reCreate map
        var groupInfoMap = new Map();
        groupInfoMap.set(this.gridColumnGroupKey, { "name": "ExpandedViewGrid", "fieldConfigs": [] });

        groupInfoMap.set(this.filterFieldGroupKey, { "name": "", "fieldConfigs": [] });
        groupInfoMap.set(this.staticFieldGroupKey, { "name": "", "fieldConfigs": [] });
        // grid
        groupInfoMap.set(this.addressesFieldGroupKey, { "name": "Addresses", "fieldConfigs": [] });
        groupInfoMap.set(this.contactMethodsFieldGroupKey, { "name": "Contact Methods", "fieldConfigs": [] });
        groupInfoMap.set(this.identifierFieldGroupKey, { "name": "Identifiers", "fieldConfigs": [] });
        groupInfoMap.set(this.consentFieldGroupKey, { "name": "Consents", "fieldConfigs": [] });
        //---
        groupInfoMap.set(this.customFieldGroupKey, { "name": "Custom Fields", "fieldConfigs": [] });
        groupInfoMap.set(this.otherFieldGroupKey, { "name": "Other Fields", "fieldConfigs": [] });


        // sort
        _templateConfigData = DataService.sortObjectByEntries(_templateConfigData, "grouprenderid");

        // extract keys
        const keys = Object.keys(_templateConfigData);
        if (DataService.hasNoElements(keys)) {
            groupInfoMap = new Map(); // clear the Map
        } else {
            let nonGroupedControls = [];
            // parse through each key
            keys.forEach(key => {
                const fieldConfig = DynamicControlService.transformFieldConfig(_templateConfigData[key]);

                if (fieldConfig.fieldID === this.companyProfileID) {
                    fieldConfig["asyncValidationCallback"] = (oRET) => { return this.validateCompanyProfileId(oRET, _compThisRef); };
                }

                if (!fieldConfig.isHidden) {

                    if (fieldConfig.fieldID === 21) {
                        fieldConfig.customLOVList = fieldConfig.customLOVList.slice().filter(k => k.lovKey.substring(0, 3) !== "US:").sort((a, b) => (a.lovKey > b.lovKey) ? 1 : ((b.lovKey > a.lovKey) ? -1 : 0));
                    }

                    var groupInfo = {};

                    if (_forGrid) { groupInfo = groupInfoMap.get(this.gridColumnGroupKey); }
                    else {
                        if (fieldConfig.isCustomField) { groupInfo = groupInfoMap.get(this.customFieldGroupKey); } // CUSTOM
                        else if (this.addressFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.addressesFieldGroupKey); } // ADDRESS-GRID
                        else if (this.contactMethodFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.contactMethodsFieldGroupKey); } // CONTACT-GRID
                        else if (this.identifierFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.identifierFieldGroupKey); } // IDENTIFIER-GRID
                        else if (this.consentFieldIds.includes(fieldConfig.fieldID)) { groupInfo = groupInfoMap.get(this.consentFieldGroupKey); } // CONSENT-GRID
                        else if (groupInfoMap.has(fieldConfig.grouprenderid)) { groupInfo = groupInfoMap.get(fieldConfig.grouprenderid); }
                        else {
                            // TODO: Enable if others is needed
                            // nonGroupedControls.push(fieldConfig);
                            // groupInfo = groupInfoMap.get(this.unmatchedFieldGroupKey);
                        } // add to unmatched
                    }

                    // push the field to the corresponding group
                    if (groupInfo.fieldConfigs) {
                        let _push = true;

                        // // hide Porzio GST Profile if new (handled in the hardcode)
                        // if (fieldConfig.fieldID === this.porzioGSTProfileID) {
                        //     _push = !_isNew; // can see only in edit
                        // } else { _push = true; }

                        // readonly
                        if (this.readonlyFieldIds.includes(fieldConfig.fieldID)) {
                            fieldConfig.isReadOnly = true;
                        }

                        // add the field
                        if (_push) { groupInfo.fieldConfigs.push(fieldConfig); }
                    }
                }
            });

            // show warnings
            if (DataService.hasElements(nonGroupedControls)) { console.warn("Controls with no GroupRendererId", nonGroupedControls); }
        }

        //sorting controls based on ordinal
        groupInfoMap.forEach(value => {
            value.fieldConfigs = value.fieldConfigs.sort((a, b) => a.ordinal - b.ordinal);
        });

        // return the Array of Arrays
        return groupInfoMap;
    }

    static hardCodeColumns = (_columnsArray) => {
        if (DataService.hasElements(_columnsArray)) {
            const index = (_columnsArray).findIndex(x => x.fieldId === ProfileTabService.porzioGSTProfileID);
            if (index === -1) {
                _columnsArray.splice(0, 0, {
                    "entityId": 1,
                    "fieldAliasName": "PORZIOGSTPROFILEID",
                    "fieldId": ProfileTabService.porzioGSTProfileID,
                    "isCustomField": false,
                    "isExpViewDefault": false,
                    "isPlsRequired": false,
                    "startIndex": 1
                });
            }
        }


        return _columnsArray;
    }

    static hardcodeFields = (_compThisRef, _isNew, _templateData) => {
        if (DataService.hasValue(_templateData)) {
            let index = 1000;
            const _templateKeys = Object.keys(_templateData) || [];
            // delete duplicate key
            let duplicateProfileStatusKey = DataService.getFirstOrDefault(_templateKeys.filter(x => x.toLowerCase().includes("profile status")));
            if (duplicateProfileStatusKey) { delete _templateData[duplicateProfileStatusKey]; }

            // Make ProfileStatus readonly and only be editable via Dialog
            _templateData.ProfileStatus = {
                // all others
                "isHidden": RolePermissionService.PROFILE_DETAILS_STATUS.cannotView,
                "isReadOnly": true,
                "fieldID": this.profileStatusFieldId,
                "fielD_NAME": "Profile Status",
                "fielD_DESCRIPTION": "Hardcoded field",
                "fieldlength": 100,
                "field_Type_ID": 5,
                "entityName": "profilestatusid",
                "fielD_ALIASNAME": "profilestatusid",
                "iS_PLSREQUIRED": true,
                "isCustomField": false,
                "lookUpList": "",
                "toolTip": "Profile Status",
                "mappedlovidfield": "profilestatusid",
                "autoSelect": _isNew, // autoselect for new
                "hideEmpty": true, // don't show none
                "customLOVList": DynamicControlService.transformToCustomLovList(
                    _isNew ? [LookupService._PROFILE_STATUSES[0]] : LookupService._PROFILE_STATUSES, "id", "value", "profilestatusid"),
                "customProfileLOVList": [],
                "customBoolean": false,
                "grouprenderid": 1,
                "endAdornmentActions": _isNew ? [] : [ // this replaces the secondary action
                    {
                        icon: MatIconService.OVERRIDE_28, tooltip: "Override Profile status", iconColor: "primary",
                        isReadOnly: RolePermissionService.PROFILE_DETAILS_STATUS.cannotEdit,
                        callback: () => {
                            if (RolePermissionService.PROFILE_DETAILS_STATUS.cannotEdit) { RolePermissionService.showAccessDeniedToast(); }
                            else { _compThisRef.setState({ showProfileStatusDialog: true }); }
                        },
                    },
                ],
            }

            //--- As per PP2-407: --------------
            // find the key if exists else use manual name
            let porzioGstProfileIdKey = DataService.getFirstOrDefault(_templateKeys.filter(x => x.toLowerCase().includes("porzio gst profile id")));
            if (porzioGstProfileIdKey) { delete _templateData[porzioGstProfileIdKey]; }
            else { porzioGstProfileIdKey = "Porzio GST Profile ID"; }
            // build the key
            let porzioGstProfileIdConfigValue = TemplateFieldConfigUtil.GET(ProfileTabService.filterFieldGroupKey, 3, ENTITY_FIELD_TYPE.TEXT, ProfileTabService.porzioGSTProfileID,
                "Porzio GST Profile ID", "PORZIOGSTPROFILEID", "PORZIOGSTPROFILEID", "Porzio GST Profile ID", "(Hardcoded field) A unique identifier assigned to each profile, auto-generated by Porzio GST.")
                .isReadOnly(true).isVisible(!_isNew).SET();
            // if required after a specific field, then find its index and pass the index here
            _templateData = DataService.addToObject(_templateData, porzioGstProfileIdKey, porzioGstProfileIdConfigValue, 1);

        }
        return _templateData;
    }


    //#region Address Grid

    static getAddressRows = (_initialValuesOrNull) => {
        const addressRows = _initialValuesOrNull ? _initialValuesOrNull.addresslist : [];
        (addressRows || []).forEach(row => {
            row["countryId"] = row["countrylist"].countryId;
            row["countryName"] = row["countrylist"].countryName;
        });
        return addressRows;
    }

    static getAddressObject = (_isprimary = false, _isactive = true,
        _addressid = "", _addresS1 = "", _addresS2 = "", _addresS3 = "", _addresS4 = "",
        _city = "", _province = "", _postalcode = "", _porziogstaddressid = "", _companyaddressid = "",
        _countrylist = { "countryId": "", "countryName": "" }
    ) => {
        return new AddressModel(_isprimary, _isactive,
            _addressid, _addresS1, _addresS2, _addresS3, _addresS4,
            _city, _province, _postalcode, _porziogstaddressid, _companyaddressid,
            _countrylist
        )
    }
    static getAddressObjectForPost = (_isprimary = false, _isactive = true,
        _addressid = "", _addresS1 = "", _addresS2 = "", _addresS3 = "", _addresS4 = "",
        _city = "", _province = "", _postalcode = "", _porziogstaddressid = "", _companyaddressid = "",
        _countrylist = { "CountryId": "", "CountryName": "", "CountryCode": "" }
    ) => {
        return new ProfileAddressModel(_isprimary, _isactive,
            _addressid, _addresS1, _addresS2, _addresS3, _addresS4,
            _city, _province, _postalcode, _porziogstaddressid, _companyaddressid,
            _countrylist
        )
    }

    static isNewAddressRow = (e) => {
        return e.data.addressid === "" || e.data.addressid <= 0;
    }


    static validateAddressRowEditOBS = (_cellRef) => {
        var oSubject = new ReplaySubject(); // 1st

        // static/async validation logic should trigger the below
        oSubject.next({ isSuccess: true }); // true <- success

        // return the subject as observable
        return oSubject.asObservable(); // 3rd
    };

    static addressFieldNamesInLowerCase = ["address1", "address2", "address3", "address4", "city", "province", "postalcode", "country", "countryid", "companyaddressid", "porziogstaddressid"];
    /**
     * Refer url for more details: https://www.ag-grid.com/javascript-grid-column-properties/
     * @param _componentThisRef pass {this} keyword from the calling componenet
     * @param _addressFieldConfigs config Array
    */
    static getAddressAgGridColumnDefs = (_componentThisRef, _isReadOnly, _showDelete, _agGridUtils) => {
        let oRET = [
            // edit button column
            _agGridUtils.getInlineEditActionColumn(_showDelete, this.validateAddressRowEditOBS),
            // other columns
            AgGridColumnExt.GET(false, "text", "isactive", "Active").fixedWidth(96).headerClass("center-text").cellRenderer("isActiveCellRenderer").SET(),
            AgGridColumnExt.GET(false, "text", "isprimary", "Primary Address").fixedWidth(96).headerClass("center-text").cellRenderer("isPrimaryCellRenderer").SET(),
            AgGridColumnExt.GET(true, "text", "addresS1", "Address 1").defaultWidth(128).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "addresS2", "Address 2").defaultWidth(128).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "addresS3", "Address 3").defaultWidth(112).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "addresS4", "Address 4").defaultWidth(112).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "city", "City").defaultWidth(128).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "province", "Province / State").defaultWidth(112).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "postalcode", "Postal Code").defaultWidth(112).SET(),
            AgGridColumnExt.GET(false, "text", "countryId", "Country").minAndDefaultWidth(192).makeMaterialDropDown(_componentThisRef.state.countryList, "id", "value", true, 0).SET(),
            // .makeDropDown(_componentThisRef.state.countryCellSource, {}, "agSelectCellEditor", _componentThisRef.state.countryList.map(o => o.id))
            AgGridColumnExt.GET(false, "text", "companyaddressid", "Company Address Id").headerTooltip().defaultWidth(112).headerClass("center-text").centerAlignText()
                .validateEditablity((e) => { return this.isNewAddressRow(e) }).SET(),
            AgGridColumnExt.GET(false, "text", "porziogstaddressid", "Porzio GST Address Id").defaultWidth(144).headerClass("center-text").centerAlignText().SET()
        ];
        return oRET;
    }

    //#endregion

    //#region Contacts Method Grid
    static getContactRows = (_initialValuesOrNull) => {
        const contactRows = DataService.hasValue(_initialValuesOrNull) ? _initialValuesOrNull.contactlist : [];
        (contactRows || []).forEach(row => {
            // add this temp key since it doesnot exists & is required for aggrid
            row["countryId"] = row["countrylist"].countryId;
            row["country"] = row["countrylist"].countryId;
            row["contacttypeid"] = row["conatacttypelist"].lovId;
            row["contacttype"] = row["conatacttypelist"].lovKey;
        });
        return contactRows;
    }

    static getContactsObject = (_ispreferred = false, _isactive = true, _companycontactid = "",
        _contactid = "", _contactinformation = "", _porziogstcontactid = "",
        _contacttypelist = { "lovId": "", "lovKey": "", "ordinal": "" },
        _countrylist = { "countryId": "", "countryName": "" }
    ) => {
        return {
            companycontactid: _companycontactid,
            conatacttypelist: _contacttypelist,     // TEMP
            contactid: _contactid,
            contactinformation: _contactinformation,
            contacttype: _contacttypelist.lovKey,
            contacttypeid: _contacttypelist.lovId,
            countryId: _countrylist.countryId,      // TEMP
            country: _countrylist.countryId,
            countrylist: _countrylist,              // TEMP
            isactive: _isactive,
            ispreferred: _ispreferred,
            porziogstcontactid: _porziogstcontactid
        };
    }
    static isNewContactRow = (e) => {
        return e.data.contactid === "" || e.data.contactid <= 0;
    }

    static validateContactRowEditOBS = (_cellRef) => {
        var oSubject = new ReplaySubject(); // 1st

        // static/async validation logic should trigger the below
        oSubject.next({ isSuccess: true }); // true <- success

        // return the subject as observable
        return oSubject.asObservable(); // 3rd
    };

    static contactsFieldNamesInLowerCase = ["contacttypeid", "contactinformation", "country", "countryid", "companycontactid", "porziogstcontactid"];

    /**
     * Refer url for more details: https://www.ag-grid.com/javascript-grid-column-properties/
     * @param _componentThisRef pass {this} keyword from the calling componenet
     * @param _contactFieldConfigs config Array
    */
    static getContactsAgGridColumnDefs = (_componentThisRef, _isReadOnly, _showDelete, _agGridUtils, _contactFieldConfigs) => {
        return [
            // edit button column
            _agGridUtils.getInlineEditActionColumn(_showDelete, this.validateContactRowEditOBS),
            // other columns
            AgGridColumnExt.GET(false, "text", "isactive", "Active Contact").fixedWidth(96).headerClass("center-text").cellRenderer("isActiveCellRenderer").SET(),
            AgGridColumnExt.GET(false, "text", "ispreferred", "Preferred Contact").fixedWidth(112).headerClass("center-text").cellRenderer("isPreferedCellRenderer").SET(),
            //AgGridColumnExt.GET(true, "text", "contacttypeid", "Contact Type").minAndDefaultWidth(144).makeDropDown(_componentThisRef.state.contactTypeCellSource).SET(),
            AgGridColumnExt.GET(false, "text", "contacttypeid", "Contact Type").minAndDefaultWidth(144).makeMaterialDropDown(_componentThisRef.state.contactTypeList,"lovId","lovKey",true,0).SET(),
            AgGridColumnExt.GET(true, "text", "contactinformation", "Contact Information").flexWeight(1).tooltip().SET(),
            AgGridColumnExt.GET(false, "text", "countryId", "Country").minAndDefaultWidth(192).makeMaterialDropDown(_componentThisRef.state.countryList, "id", "value", true, 0).SET(),
            // AgGridColumnExt.GET(true, "text", "countryId", "Contact Country").minAndDefaultWidth(192).makeDropDown(_componentThisRef.state.countryCellSource, {}, "agSelectCellEditor", _componentThisRef.state.countryList.map(o => o.id)).SET(),
            AgGridColumnExt.GET(false, "text", "companycontactid", "Company Contact Id").defaultWidth(112).headerClass("center-text").centerAlignText()
                .validateEditablity((e) => { return this.isNewContactRow(e) }).SET(),
            AgGridColumnExt.GET(false, "text", "porziogstcontactid", "Porzio GST Contact Id").defaultWidth(144).headerClass("center-text").centerAlignText().SET(),
        ];
    }

    //#endregion


    //#region Identifier Method Grid
    static getIdentifierRows = (_initialValuesOrNull) => {
        const identifierRows = DataService.hasValue(_initialValuesOrNull) ? _initialValuesOrNull.identifierlist : [];
        // (identifierRows || []).forEach(row => {
        // });
        return identifierRows;
    }

    static getIdentifierObject = (
        _porzioGSTIdentifierTypeId = 0,
        _companyIdentifierID = "",
        _countryId = "",
        _countryInfo = { "countryId": "", "countryName": "", "countryCode": "" },
        _identifierDescription = "",
        _identifierValue = "",
        _porzioGSTIdentifierType = { "lovId": 0, "lovKey": "", "ordinal": 0, "isdefault": false, "fieldName": "", "localLovKey": "" },
        _porzioGSTIdentifierID = "",
        _profileIdentifierId = 0,
    ) => {
        return {
            "porzioGSTIdentifierTypeId": _porzioGSTIdentifierTypeId,
            "companyIdentifierID": _companyIdentifierID,
            "countryId": _countryId,
            "countryInfo": {
                "countryId": _countryInfo.countryId,
                "countryName": _countryInfo.countryName,
                "countryCode": _countryInfo.countryCode
            },
            "identifierDescription": _identifierDescription,
            "identifierValue": _identifierValue,
            "porzioGSTIdentifierType": {
                "lovId": _porzioGSTIdentifierType.lovId,
                "lovKey": _porzioGSTIdentifierType.lovKey,
                "ordinal": _porzioGSTIdentifierType.ordinal,
                "isdefault": _porzioGSTIdentifierType.isdefault,
                "fieldName": _porzioGSTIdentifierType.fieldName,
                "localLovKey": _porzioGSTIdentifierType.localLovKey
            },
            "porzioGSTIdentifierID": _porzioGSTIdentifierID,
            "profileIdentifierId": _profileIdentifierId,
        };
    }

    static isNewIdentifierRow = (e) => {
        return e.data.companyIdentifierID === "" || e.data.companyIdentifierID <= 0;
    }

    static validateIdentifierRowEditOBS = (_cellRef) => {
        var oSubject = new ReplaySubject(); // 1st

        // static/async validation logic should trigger the below
        oSubject.next({ isSuccess: true }); // true <- success

        // return the subject as observable
        return oSubject.asObservable(); // 3rd
    };


    // static identifierFieldNamesInLowerCase = ["contacttypeid", "contactinformation", "country", "countryid", "companycontactid", "porziogstcontactid"];


    /**
     * Refer url for more details: https://www.ag-grid.com/javascript-grid-column-properties/
     * @param _componentThisRef pass {this} keyword from the calling componenet
    */
    static getIdentifierAgGridColumnDefs = (_componentThisRef, _isReadOnly, _showDelete, _agGridUtils) => {
        const arrSort = _componentThisRef.state.porzioGstIdentifierTypeList.slice().sort((a, b) => (a.lovKey > b.lovKey) ? 1 : ((b.lovKey > a.lovKey) ? -1 : 0)).map(i => i.lovId);
        //const arrSort = _componentThisRef.state.porzioGstIdentifierTypeList.filter(k => k.lovKey.substring(0, 3) !== "US:").map(i => i.lovId); // this preserves the alphabetical sort order of the drop down
        let oRET = [
            // edit button column
            _agGridUtils.getInlineEditActionColumn(_showDelete, this.validateIdentifierRowEditOBS),

            // other columns
            // Note this first key must match the default focus key in this Service's corresponding Component: new AgGridUtil()
            AgGridColumnExt.GET(true, "text", "porzioGSTIdentifierTypeId", "Porzio GST Identifier Type").minAndDefaultWidth(384).makeDropDown(_componentThisRef.state.porzioGstIdentifierTypeCellSource, {}, "agSelectCellEditor", ["", ...arrSort]).SET(),
            AgGridColumnExt.GET(true, "text", "countryId", "Country").minAndDefaultWidth(192).makeDropDown(_componentThisRef.state.countryCellSource, {}, "agSelectCellEditor", _componentThisRef.state.countryList.map(o => o.id)).SET(),
            AgGridColumnExt.GET(true, "text", "identifierValue", "Identifier Value").minAndDefaultWidth(192).tooltip().SET(),
            AgGridColumnExt.GET(true, "text", "identifierDescription", "Identifier Description").minAndDefaultWidth(130).flexWeight(1).tooltip().SET(),

            AgGridColumnExt.GET(false, "text", "companyIdentifierID", "Company Identifier Id").fixedWidth(128).headerClass("center-text").centerAlignText()
                .validateEditablity((e) => { return this.isNewIdentifierRow(e) }).SET(),
            AgGridColumnExt.GET(false, "text", "porzioGSTIdentifierID", "Porzio GST Identifier Id").fixedWidth(144).headerClass("center-text").centerAlignText()
                .SET()
        ];
        return oRET;
    }

    //#endregion



    //#region Consent Method Grid
    static getConsentRows = (_consentList) => {
        let consentRows = DataService.hasElements(_consentList) ? _consentList : [];
        // consentRows.map(x => x.delete = false);
        return consentRows;
    }

    static getConsentObject = (
        _profileConsentId = 0,
        _profileConsent = "",
        _profileConsentName = "",
        _profileConsentStartDate = "",
        _profileConsentEndDate = "",
        _profileConsentExecuteDate = "",
    ) => {
        return {
            "profileConsentId": _profileConsentId,
            "profileConsent": _profileConsent,
            "profileConsentName": _profileConsentName,
            "profileConsentStartDate": _profileConsentStartDate,
            "profileConsentEndDate": _profileConsentEndDate,
            "profileConsentExecuteDate": _profileConsentExecuteDate,
        };
    }

    static isNewConsentRow = (e) => {
        return e.data.profileConsentId === "" || e.data.profileConsentId <= 0;
    }

    static validateConsentRowEditOBS = (_cellRef) => {
        var oSubject = new ReplaySubject(); // 1st

        // static/async validation logic should trigger the below
        oSubject.next({ isSuccess: true }); // true <- success

        // return the subject as observable
        return oSubject.asObservable(); // 3rd
    };


    // static identifierFieldNamesInLowerCase = ["contacttypeid", "contactinformation", "country", "countryid", "companycontactid", "porziogstcontactid"];


    /**
     * Refer url for more details: https://www.ag-grid.com/javascript-grid-column-properties/
     * @param _componentThisRef pass {this} keyword from the calling componenet
    */
    static getConsentAgGridColumnDefs = (_componentThisRef, _isReadOnly, _showDelete, _agGridUtils) => {
        return [
            // edit button column
            _agGridUtils.getInlineEditActionColumn(_showDelete, this.validateConsentRowEditOBS),
            // other columns
            AgGridColumnExt.GET(true, "text", "profileConsent", "Consent").minAndDefaultWidth(192).makeDropDown(_componentThisRef.state.consentLovList).SET(),
            AgGridColumnExt.GET(false, "text", "profileConsentStartDate", "Start Date").flexWeight(1).cellRenderer("dateCellRenderer").SET(),
            AgGridColumnExt.GET(false, "text", "profileConsentEndDate", "End Date").flexWeight(1).cellRenderer("dateCellRenderer").SET(),
            AgGridColumnExt.GET(false, "text", "profileConsentExecuteDate", "Executed Date").flexWeight(1).cellRenderer("dateCellRenderer").SET(),

        ];
    }

    //#endregion

    static validateCompanyProfileId = (oRET, _componentThisRef) => {
        let valSchema = oRET
            .test("checkDuplicateCompanyProfileId", "Company Profile Id already exists", async (_formikValue) => {
                if (_componentThisRef.props.inputAction === CrudAction.UPDATE) {
                    return true;
                } else {
                    try {
                        const result = await fetch(`${process.env.REACT_APP_CORE_HTTP}/Profiles/CheckIfProfileAvailable/${_componentThisRef.context.user.tenantId}/${_formikValue}`);
                        const isExists = await result.json();
                        return !isExists;
                    } catch {
                        return false;
                    }
                }
            })
        return valSchema;
    }

    //---
}